// extracted by mini-css-extract-plugin
export default {"loading":"LoadingPage_loading__wGIs7","title":"LoadingPage_title__z48Y2"};